import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const engToBnMap: Record<string, string> = {
  '0': '০',
  '1': '১',
  '2': '২',
  '3': '৩',
  '4': '৪',
  '5': '৫',
  '6': '৬',
  '7': '৭',
  '8': '৮',
  '9': '৯',
}

export function toBanglaNumber(num: number | string): string {
  return num.toString().replace(/\d/g, (match) => engToBnMap[match] || match)
}

export function formatCurrency(amount: number): string {
  return `৳${toBanglaNumber(amount.toLocaleString('en-IN'))}`
}
